/* eslint-disable sort-keys-fix/sort-keys-fix */
import { COMMUNITY_PAGES_PATH_PREFIX, type CommunityData } from "./types"

const S3_PREFIX = "https://media.werz.at/community-assets/koichacollective/"

const KOICHA_COLLECTIVE: CommunityData = {
  code: "koichacollective",
  inviteCode: "koichacollective",
  name: "Koicha Collective",
  thumbnail: "",
  favicon: "",
  defaultCurrency: "SEK",
  url: `${COMMUNITY_PAGES_PATH_PREFIX}/koi-046`,
  waitlist: true,
  socials: {},
  styles: {
    global: {
      counterColor: "#000000",
      logo: {
        src: `${S3_PREFIX}web-logo.jpg`,
        styles: "w-[160px] h-[41px] object-contain",
      },
      alternativeLogo: {
        src: `${S3_PREFIX}web-alternative-logo.png`,
        styles: "w-[160px] h-[41px]",
      },
      modalWindow: {
        container: "",
        title: "",
        subtitle: "",
      },
      bgColor: "#92b775",
      asideBg: "#92b775",
      asideStyles: "!gap-0 !py-0 border-r border-[#000000]",
      contentBg: "",
      contentBoxShadow: "",
      bgDesktop: `${S3_PREFIX}web-background.jpg`,
      bgMobile: `${S3_PREFIX}web-background-mobile.jpg`,
      nonMemberBg: `${S3_PREFIX}web-background-non-member.jpg`,
      mainFont: "font-['FixelTextRegular']",
      primaryButton:
        "bg-[#ffffff] border border-[#000000] rounded-[12px] px-[18px] py-[18px] !text-[#000000] font-['Hello-GoopsRegular'] !text-[18px] text-left leading-[100%]",
    },
    navigation: {
      iconsColor: "#222222",
      sideBarSeparator: "border-r-[1px] border-[#000000]",
      separator: "border-[#000000]",
      item: "font-['FixelTextSemiBold'] text-[16px] text-[#222222] text-left leading-[100%] gap-x-[10px] text-opacity-50 text-center border-b border-[#000000] !pl-0 !py-3",
      itemSelected: "!text-opacity-100",
    },
    communityLanding: {
      container: "!bg-[#92b775] border border-[#000000] rounded-[24px] !pb-8",
      titles: "text-[#000000] font-['Hello-GoopsRegular'] text-[32px] text-left leading-[100%]",
      emptyOrLoadingState:
        "!mx-4 sm:!mx-8 text-[#000000] font-['FixelTextRegular'] text-[14px] text-left leading-[120%]",
      announcementsV2: {
        sectionContainer: "py-4 sm:py-8 !m-0 space-y-0 !border-0 !border-b border-[#000000]",
        sectionTitle:
          "text-[#000000] font-['Hello-GoopsRegular'] text-[32px] text-left leading-[100%] pl-4 sm:pl-8 !mb-4 sm:mb-6",
        scrollMenu: {
          container: "content-start hide-scroll pl-4 sm:pl-8 pr-6 sm:pr-8 gap-x-4",
          wrapper: "relative group",
          item: "w-fit",
        },
        item: {
          container:
            "min-w-[calc(100vw-48px)] sm:min-w-[256px] sm:max-w-[256px] overflow-hidden bg-[#ffffff00]",
          mediaContainer:
            "w-[256px] h-[256px] relative border border-[#000000] rounded-[16px] overflow-hidden",
          media: "w-[256px] h-[256px] object-cover rounded-[16px]",
          placeholderMedia: "w-[256px] h-[256px] bg-gray-400 rounded-[16px]",
          content: "flex flex-col py-4 bg-transparent",
          title: "text-[#000000] font-['Hello-GoopsRegular'] text-[22px] text-left leading-[100%]",
          subtitle:
            "text-[#000000] font-['FixelTextRegular'] text-[12px] text-left leading-[120%] mt-2",
        },
      },
      eventsV2: {
        sectionContainer: "py-4 sm:py-8 !m-0 space-y-0 !border-0 !border-b border-[#000000]",
        sectionTitle:
          "text-[#000000] font-['Hello-GoopsRegular'] text-[32px] text-left leading-[100%] pl-4 sm:pl-8 !mb-4 sm:mb-6",
        scrollMenu: {
          container:
            "content-start hide-scroll pl-4 sm:pl-8 pr-6 sm:pr-8 !h-full sm:!h-[128px] flex-row gap-6",
          wrapper: "relative group w-full",
          item: "w-fit",
        },
        item: {
          container:
            "flex sm:flex-row flex-col w-[calc(100vw-56px)] sm:!w-[428px] h-full overflow-hidden bg-[#ffffff00]",
          mediaContainer:
            "w-full sm:!w-[228px] sm:flex-shrink-0 relative border border-[#000000] rounded-[16px] overflow-hidden",
          media: "w-full !aspect-video object-cover rounded-[16px]",
          placeholderMedia: "w-full h-full bg-gray-400 rounded-[16px]",
          content: "flex flex-col px-4 py-4 sm:py-0 bg-transparent",
          title: "text-[#000000] font-['FixelTextSemiBold'] text-[15px] text-left leading-[100%]",
          subtitle:
            "text-[#000000] font-['FixelTextRegular'] text-[12px] text-left leading-[120%] mt-2",
          location:
            "text-[#000000] font-['FixelTextRegular'] text-[12px] text-left leading-[120%] mt-1",
          date: "text-[#000000] font-['FixelTextRegular'] text-[12px] text-left leading-[120%] mt-2",
        },
      },
      shop: {
        container: "py-4 sm:py-8 !pb-16 !m-0 space-y-0 !border-0 overflow-hidden",
        title: "text-[#000000] font-['Hello-GoopsRegular'] text-[28px] text-left leading-[100%]",
        text: "text-[#000000] font-['FixelTextRegular'] text-[16px] text-left leading-[120%]",
        customShopImageStyle: "border border-[#000000] rounded-[16px]",
        sectionTitle:
          "text-[#000000] font-['Hello-GoopsRegular'] text-[32px] text-left leading-[100%] !mb-4 sm:mb-6",
      },
    },
    eventV2: {
      container: "flex flex-col !bg-[#92b775] border border-[#000000] rounded-[24px] !pb-8",
      eventInfo: {
        container: "flex flex-col sm:flex-row gap-4 sm:gap-6 sm:p-8 p-4 border-b border-[#000000]",
        media:
          "sm:!w-[320px] !w-full !h-[180px] object-cover sm:mb-4 border border-[#000000] rounded-[16px]",
        title: "text-[#000000] font-['Hello-GoopsRegular'] text-[32px] text-left leading-[100%]",
        subtitle:
          "text-[#000000] font-['FixelTextRegular'] text-[14px] text-left leading-[120%] mb-4 mt-2",
        button:
          "bg-[#ffffff] border border-[#000000] rounded-[12px] px-[18px] py-[18px] gap-y-[6px] !w-fit mb-4 sm:mb-0 text-[#000000] font-['Hello-GoopsRegular'] !text-[18px] text-left leading-[100%]",
        questions: "text-[14px] text-left leading-[120%] text-[#000000]",
      },
      about: {
        container: "flex flex-col gap-4 sm:p-8 p-4 border-b border-[#000000]",
        header: "text-[#000000] font-['Hello-GoopsRegular'] text-[28px] text-left leading-[100%]",
        text: "text-[#000000] font-['FixelTextRegular'] text-[14px] text-left leading-[120%] mb-4 w-full",
      },
      location: {
        container: "flex flex-col gap-4 sm:p-8 p-4 border-b border-[#000000]",
        header: "text-[#000000] font-['Hello-GoopsRegular'] text-[28px] text-left leading-[100%]",
        text: "text-[#000000] font-['FixelTextRegular'] text-[14px] text-left leading-[120%] mb-4 max-w-[652px] w-full",
        map: "w-full h-[206px] border border-[#000000] rounded-[16px] overflow-hidden gap-y-[10px]",
        mapPinColor: "#000000",
        mapStrokeColor: "#00000000",
      },
      downloadWERZ: {
        container: "flex flex-col gap-4 sm:p-8 p-4",
        header: "text-[#000000] font-['Hello-GoopsRegular'] text-[28px] text-left leading-[100%]",
        text: "text-[#000000] font-['FixelTextRegular'] text-[14px] text-left leading-[120%]",
      },
      tickets: {
        header:
          "text-[#000000] font-['Hello-GoopsRegular'] text-[28px] text-left leading-[100%] px-4 sm:px-8 pt-4 sm:pt-8 mb-2 sm:mb-4 flex justify-between items-center",
        outerContainer: "flex flex-col !bg-[#92b775]",
        innerContainer: "flex flex-col px-4 sm:px-8",
        accessCode: {
          button:
            "bg-[#809b67] border border-[#000000] rounded-[12px] px-[16px] py-[16px] text-[#000000] font-['Hello-GoopsRegular'] text-[15px] text-left leading-[100%] !w-fit",
        },
        ticket: {
          container:
            "flex flex-row justify-between leading-auto !bg-[#ffffff00] py-4 border-b border-[#000000]",
          mediaContainer: "!hidden",
          media: "!hidden",
          name: "text-[#000000] font-['FixelTextSemiBold'] text-[15px] text-left leading-[100%] mb-1",
          description:
            "text-[#000000] font-['FixelTextRegular'] text-[14px] text-left leading-[120%] mb-1 flex flex-row",
          price: "text-[#000000] font-['FixelTextSemiBold'] text-[15px] text-left leading-[100%]",
          quantity:
            "text-[#000000] font-['Hello-GoopsRegular'] text-[15px] text-left leading-[100%]",
          status: "text-[#000000] font-['FixelTextSemiBold'] text-[15px] text-left leading-[100%]",
          counterContainer:
            "bg-[#809b67] border border-[#000000] rounded-[12px] px-[16px] py-[16px] gap-x-[16px] !w-fit",
          button:
            "bg-[#809b67] border border-[#000000] rounded-[12px] px-[16px] py-[16px] text-[#000000] font-['Hello-GoopsRegular'] text-[15px] text-left leading-[100%] !w-fit",
          plusMinusColor: "#000000",
        },
      },
    },
    linktree: {
      bgDesktop: `${S3_PREFIX}web-background-non-member.jpg`,
      bgMobile: `${S3_PREFIX}web-background-non-member.jpg`,
      bgColor: "#92b775",
      bgMedia: "object-cover object-center",
      container:
        "flex flex-col items-center h-full w-full bg-center bg-cover bg-no-repeat min-h-screen relative px-4 py-12 sm:p-[64px] bg-[#92b775]",
      communityInfo: {
        logo: "h-[128px] w-[128px] rounded-full border border-[2.5px] object-cover border-[#000000]",
        name: "text-[#000000] font-['Hello-GoopsRegular'] text-[24px] text-center mt-4 mb-1",
        location: "text-[#000000] font-['Hello-GoopsRegular'] text-[16px] text-center mb-2",
        description:
          "text-[#000000] font-['FixelTextRegular'] text-[16px] text-center leading-[120%] mb-4 max-w-[500px]",
        socialMediaIconColor: "#000000",
        button:
          "bg-[#809b67] border border-[#000000] rounded-[12px] px-[16px] py-[16px] text-[#000000] font-['Hello-GoopsRegular'] text-[15px] text-left leading-[100%] w-fit cursor-pointer",
      },
      upcomingEvents: {
        loadingState:
          "mb-[32px] h-[56px] sm:w-[500px] w-[95vw] px-4 flex items-center bg-[#92b775] border border-[#000000] rounded-[8px] text-[#000000] font-['FixelTextRegular'] text-[16px] leading-[120%] text-center",
        emptyState: {
          container:
            "sm:w-[500px] w-[95vw] flex flex-col justify-center items-center p-[34px] mb-[32px] bg-[#92b775] border border-[#000000] rounded-[8px]",
          title: "text-[#000000] font-['Hello-GoopsRegular'] text-[16px] text-center mb-1",
          text: "text-[#000000] font-['FixelTextRegular'] text-[16px] leading-[120%] text-center",
          button:
            "bg-[#809b67] border border-[#000000] rounded-[12px] px-[16px] py-[16px] text-[#000000] font-['Hello-GoopsRegular'] text-[15px] text-left leading-[100%] w-fit cursor-pointer mt-4",
        },
        header: "text-[#000000] font-['Hello-GoopsRegular'] text-[16px] text-center mb-[10px]",
        container: "sm:w-[500px] w-[95vw] gap-4 flex flex-col items-center overflow-hidden",
        collapsedEvent: {
          container:
            "h-[64px] cursor-pointer sm:w-[500px] w-[95vw] flex justify-between bg-[#92b775] border border-[#000000] rounded-[8px]",
          duration: "text-[#000000] font-['FixelTextRegular'] text-[14px] leading-[120%] text-left",
          name: "text-[#000000] font-['Hello-GoopsRegular'] text-[16px] text-left one-line-truncate sm:w-[390px] w-[65vw]",
          plusIconColor: "#000000",
          media: "overflow-hidden m-2 border border-[#000000]",
        },
        event: {
          container:
            "overflow-hidden sm:w-[500px] w-[95vw] bg-[#92b775] border border-[#000000] rounded-[8px]",
          name: "text-[#000000] font-['Hello-GoopsRegular'] text-[16px] text-left mb-1 one-line-truncate sm:w-[370px] w-[60vw]",
          startDate:
            "w-[68px] h-[68px] flex flex-col justify-center items-center gap-1 bg-[#809b67] border border-[#000000] rounded-[6px] text-[#000000] font-['Hello-GoopsRegular'] text-[14px] text-center",
          duration: "text-[#000000] font-['FixelTextRegular'] text-[14px] leading-[120%] text-left",
          location: "text-[#000000] font-['FixelTextRegular'] text-[14px] leading-[120%] text-left",
          button:
            "bg-[#809b67] border border-[#000000] rounded-[12px] px-[16px] py-[16px] text-[#000000] font-['Hello-GoopsRegular'] text-[15px] text-left leading-[100%] w-fit cursor-pointer mt-3",
          product: {
            container:
              "min-h-[68px] px-4 py-3 flex justify-between gap-4 border-t border-[#000000]",
            name: "text-[#000000] font-['FixelTextSemiBold'] text-[14px] text-left one-line-truncate sm:w-[390px] w-[65vw]",
            price: "text-[#000000] font-['FixelTextSemiBold'] text-[14px] text-left",
            link: "text-[#000000] font-['FixelTextRegular'] text-[12px] leading-[120%] text-left",
            status:
              "text-[#000000] font-['FixelTextSemiBold'] text-[14px] leading-[100%] text-left",
            button:
              "bg-[#809b67] border border-[#000000] rounded-[12px] px-[16px] py-[16px] text-[#000000] font-['Hello-GoopsRegular'] text-[15px] text-left leading-[100%] w-fit cursor-pointer",
          },
        },
        seeAllEvents:
          "text-[#000000] font-['FixelTextRegular'] text-[16px] leading-[120%] text-center mt-4 cursor-pointer mb-[32px] underline",
      },
      news: {
        loadingState:
          "mb-[32px] h-[56px] sm:w-[500px] w-[95vw] px-4 flex items-center bg-[#92b775] border border-[#000000] rounded-[8px] text-[#000000] font-['FixelTextRegular'] text-[16px] leading-[120%] text-center",
        header: "text-[#000000] font-['Hello-GoopsRegular'] text-[16px] text-center mb-[10px]",
        container: "flex flex-col gap-4",
        oneNews: {
          container:
            "h-[64px] cursor-pointer sm:w-[500px] w-[95vw] flex justify-between bg-[#92b775] border border-[#000000] rounded-[8px]",
          name: "text-[#000000] font-['Hello-GoopsRegular'] text-[16px] text-left one-line-truncate sm:w-[390px] w-[65vw]",
          triangleIconColor: "#000000",
          created: "text-[#000000] font-['FixelTextRegular'] text-[14px] leading-[120%] text-left",
          media: "overflow-hidden m-2 border border-[#000000]",
        },
        seeAllNews:
          "text-[#000000] font-['FixelTextRegular'] text-[16px] leading-[120%] text-center mt-4 cursor-pointer mb-[32px] underline",
      },
      otherLinks: {
        loadingState:
          "mb-[32px] h-[56px] sm:w-[500px] w-[95vw] px-4 flex items-center bg-[#92b775] border border-[#000000] rounded-[8px] text-[#000000] font-['FixelTextRegular'] text-[16px] leading-[120%] text-center",
        header: "text-[#000000] font-['Hello-GoopsRegular'] text-[16px] text-center mb-[10px]",
        container: "flex flex-col gap-[10px] mb-[40px]",
        link: {
          container:
            "h-[64px] cursor-pointer p-2 sm:w-[500px] w-[95vw] flex justify-between bg-[#92b775] border border-[#000000] rounded-[8px]",
          name: "text-[#000000] font-['Hello-GoopsRegular'] text-[16px] text-left",
          triangleIconColor: "#000000",
          circleIcon: "ml-2 w-[24px] h-[24px] rounded-full object-cover border border-[#000000]",
        },
      },
      footer: {
        WERZlogoColor: "#000000",
        text: "text-[#000000] font-['FixelTextRegular'] text-[12px] text-left",
      },
    },
  },
}

export default KOICHA_COLLECTIVE
